import { CONTESTS_SHOW_SUCCESS } from '../actions/contests';
import { ROUND_SELECT } from '../actions/round';

const defaultState = { round: null, categories: null };

export default (state = defaultState, { type, payload = defaultState }) => {
  switch (type) {
    case ROUND_SELECT: {
      return payload;
    }

    case CONTESTS_SHOW_SUCCESS: {
      if (payload.selectedRound && (payload.forceRoundUpdate || !state.round)) {
        return {
          round: payload.selectedRound,
          categories: payload.selectedRoundCategories,
        };
      }

      return state;
    }

    default: {
      return state;
    }
  }
};
